import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AnalyticsService } from 'src/app/analytics/analytics.service';
import { AnalyticsEvent, NewOrderType } from 'src/app/analytics/models/analytics-event';

export interface ProtocolTypeSelection {
    type: 'complete' | 'quick';
}

@Component({
    selector: 'app-modal-select-protocol-type',
    templateUrl: './modal-select-protocol-type.component.html',
    styleUrls: ['./modal-select-protocol-type.component.scss']
})
export class ModalSelectProtocolTypeComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ModalSelectProtocolTypeComponent>,
        private readonly analytics: AnalyticsService
    ) { }

    ngOnInit() {
        this.analytics.track(AnalyticsEvent.WorkOrderView, {
            ...this.analytics.globalProps(),
        });
    }

    onSelectComplete(): void {
        this.sendAnalyticsEvent('complete')
        this.dialogRef.close({ type: 'complete' } as ProtocolTypeSelection);
    }

    onSelectQuick(): void {
        this.sendAnalyticsEvent('quick')
        this.dialogRef.close({ type: 'quick' } as ProtocolTypeSelection);
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    sendAnalyticsEvent(type: string) {
        this.analytics.track(AnalyticsEvent.WorkOrderClick, {
            ...this.analytics.globalProps(),
            orderType: type as NewOrderType
        });
    }
}
